import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/AuthContext";
import RequireAuth from "@/components/RequireAuth";
import HeadMeta from "@/components/HeadMeta";

import Landing from "@/pages/Landing";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import PasswordReset from "@/pages/PasswordReset";
import EarlyAccess from "@/pages/EarlyAccess";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import UploadPage from "@/pages/UploadPage";
import MappingPage from "@/pages/MappingPage";
import ReorderPage from "@/pages/ReorderPage";
import SlowPage from "@/pages/SlowPage";
import PricingIntelPage from "@/pages/PricingIntelPage";
import MarketPage from "@/pages/MarketPage";
import RecommendationsPage from "@/pages/RecommendationsPage";
import AskPage from "@/pages/AskPage";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import DealerBio from "@/pages/DealerBio";
import SettingsBilling from "@/pages/SettingsBilling";
import SettingsTemplates from "@/pages/SettingsTemplates";
import SettingsPreferences from "@/pages/SettingsPreferences";
import SettingsLocations from "@/pages/SettingsLocations";
import SettingsBrand from "@/pages/SettingsBrand";
import ReportCard from "@/pages/ReportCard";
import NotFound from "@/pages/NotFound";
import SettingsPricingStrategy from "@/pages/SettingsPricingStrategy";
import Demo from "@/pages/Demo";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <HeadMeta />
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/password-reset" element={<PasswordReset />} />
            <Route path="/early-access" element={<EarlyAccess />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/app/onboarding" element={<RequireAuth requireOrg={false}><Onboarding /></RequireAuth>} />
            <Route path="/app" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/app/upload" element={<RequireAuth><UploadPage /></RequireAuth>} />
            <Route path="/app/upload/:id/map" element={<RequireAuth><MappingPage /></RequireAuth>} />
            <Route path="/app/reorder" element={<RequireAuth><ReorderPage /></RequireAuth>} />
            <Route path="/app/slow" element={<RequireAuth><SlowPage /></RequireAuth>} />
            <Route path="/app/pricing" element={<RequireAuth><PricingIntelPage /></RequireAuth>} />
            <Route path="/app/market" element={<RequireAuth><MarketPage /></RequireAuth>} />
            <Route path="/app/recommendations" element={<RequireAuth><RecommendationsPage /></RequireAuth>} />
            <Route path="/app/ask" element={<RequireAuth><AskPage /></RequireAuth>} />
            <Route path="/app/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
            <Route path="/app/settings/billing" element={<RequireAuth><SettingsBilling /></RequireAuth>} />
            <Route path="/app/settings/templates" element={<RequireAuth><SettingsTemplates /></RequireAuth>} />
            <Route path="/app/settings/preferences" element={<RequireAuth><SettingsPreferences /></RequireAuth>} />
            <Route path="/app/settings/locations" element={<RequireAuth><SettingsLocations /></RequireAuth>} />
            <Route path="/app/settings/pricing-strategy" element={<RequireAuth><SettingsPricingStrategy /></RequireAuth>} />
            <Route path="/app/settings/brand" element={<RequireAuth><SettingsBrand /></RequireAuth>} />
            <Route path="/app/report-card" element={<RequireAuth><ReportCard /></RequireAuth>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/dealer/:code" element={<DealerBio />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
